import { Injectable } from '@angular/core';
import { throwError, Observable } from 'rxjs';
import { environment } from '../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class Globals {

  // public serviceUrl: string = environment.serviceUrl;
  // public readonly baseproducturl:string=environment.baseproducturl;
  // public successurl: string = environment.successurl;
  // public failurl: string =environment.failurl;
  public passwordpattern = environment.passwordpattern;
  validationObject: any;

  // Check value is undefined/null/''/length =0
  public isEmpty(val) {
    return (val === undefined || val === null || val.length <= 0 || val === '') ? true : false;
  }

  // Check value is undefined/null/''/0
  public isEmptyNumeric(val) {
    return (val === undefined || val === null || val == 0 || val === '') ? true : false;
  }

  public handleError(err) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage: string;
    if (err) {
      if (err.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        errorMessage = `An error occurred: ${err.error.message}`;
      } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        if (err.status === '401') {
          errorMessage = 'Sorry, you must have a valid login and password';
        }
        else {
          if (err.error) {
            errorMessage = err.error.ErrorMessage;
          }
          else {
            errorMessage = `Backend returned code ${err.status}`;
          }
        }
      }
    }
    return throwError(errorMessage);
  }
}
